export default __webpack_public_path__ + "static/media/Web_Grudge_Effect.bd1f91c9.svg";